<script setup lang="ts">
import type {Media} from '~/types/legacy'

const backgrounds = {
  white: 'bg-white',
  dark: 'bg-gray-900',
  primary: 'bg-primary-lighter',
} as const

defineProps<{
  image: Media
  variant: keyof typeof backgrounds
}>()
</script>

<template>
  <a
    :href="image.url ?? undefined"
    download
    class="group relative flex items-center justify-center rounded-lg p-8 shadow"
    :class="backgrounds[variant]"
  >
    <NuxtImg v-bind="resolveMediaProps(image)" class="h-full w-full object-contain" />
    <div
      class="absolute bottom-4 right-4 flex h-8 items-center rounded bg-white px-2 text-sm opacity-0 shadow transition group-hover:opacity-100"
    >
      Download
    </div>
  </a>
</template>
